import React from "react";
import { Helmet } from "react-helmet";
import { BreadcrumbStructuredData } from "./StructuredData/breadcrumb-structured-data";
import { ProductStructuredData } from "./StructuredData/product-structured-data";
import { ServiceStructuredData } from "./StructuredData/service-structured-data";

export { buildBreadcrumbStructuredData } from "./StructuredData/breadcrumb-structured-data";
export { buildProductStructuredData } from "./StructuredData/product-structured-data";
export { buildServiceStructuredData } from "./StructuredData/service-structured-data";

interface StructuredDataProps {
  structuredData:
    | BreadcrumbStructuredData
    | ProductStructuredData
    | ServiceStructuredData;
}

export function StructuredData({ structuredData }: StructuredDataProps) {
  return (
    <Helmet encodeSpecialCharacters={false}>
      <script type="application/ld+json">
        {JSON.stringify(structuredData)}
      </script>
    </Helmet>
  );
}
